// /* hpo-configurator.js — custom façade for Hulk Product Options (see CLAUDE.md).
//    Pipeline: waitForHulk → fetchOptions → normalize → render → bridge → menu/guests/CTA →
//    conditional mirror (hides sets/cards the app has hidden via its own Conditional Logic rules).
//    The app's hidden DOM stays the source of truth; we mirror every interaction into it and
//    re-read its state afterwards. `hpo-ready` is added to <body> only after a successful render;
//    on any error it is removed so the app's original UI stays the customer-facing fallback. */
// (function () {
//   'use strict';

//   var root = document.querySelector('[data-hpo-root]');
//   if (!root) return;

//   var cfg = {
//     productId: root.dataset.productId,
//     showMenu: root.dataset.showMenu === 'true',
//     scrollOffset: parseInt(root.dataset.scrollOffset, 10) || 0, // extra padding, not the full offset
//     extrasOpen: root.dataset.extrasOpen === 'true',
//     optionalLabel: root.dataset.optionalLabel || 'OPTIONAL',
//     optionalHint: root.dataset.optionalHint || '',
//     extraHint: root.dataset.extraHint || '',
//     extrasSelectedLabel: root.dataset.extrasSelectedLabel || 'ausgewählt',
//     guestsMin: parseInt(root.dataset.guestsMin, 10) || 1,
//     guestsStep: parseInt(root.dataset.guestsStep, 10) || 1,
//     ctaOpen: root.dataset.ctaLabelOpen || '',
//     ctaReady: root.dataset.ctaLabelReady || '',
//     descriptionsUrl: root.dataset.descriptionsUrl || '',
//     badgeLabel: root.dataset.badgeLabel || ''
//   };

//   var els = {
//     sets: root.querySelector('[data-slot="sets"]'),
//     notes: root.querySelector('[data-slot="notes"]'),
//     menu: root.querySelector('[data-slot="menu"]'),
//     cta: root.querySelector('[data-slot="cta"]'),
//     ctaLabel: root.querySelector('[data-slot="cta-label"]')
//   };

//   var HPO = (window.HPO = { root: root, cfg: cfg, state: null, ready: false, raw: null });

//   // the gallery lives outside [data-hpo-root], so copy the schema-driven vars up to the
//   // shared .product-detail ancestor (CSS falls back to the defaults until this runs)
//   var productDetail = root.closest('.product-detail');
//   if (productDetail) {
//     productDetail.style.setProperty('--hpo-image-radius', (parseInt(root.dataset.imageRadius, 10) || 12) + 'px');
//     var accent = getComputedStyle(root).getPropertyValue('--hpo-accent').trim();
//     if (accent) productDetail.style.setProperty('--hpo-accent', accent);
//   }

//   // Mode sets .selected on a thumbnail only when it is clicked — nothing is marked on load
//   // and swiping the main image never updates it. Keep the thumbs in sync with slick's
//   // current slide instead of reimplementing the carousel.
//   (function wireGalleryActiveThumb() {
//     var gallery = productDetail && productDetail.querySelector('.gallery');
//     var slideshow = gallery && gallery.querySelector('.product-slideshow');
//     var thumbs = gallery ? gallery.querySelectorAll('.thumbnail[data-media-id]') : [];
//     if (!slideshow || !thumbs.length) return;
//     function sync() {
//       var cur = slideshow.querySelector('.slick-current');
//       var id = cur && cur.getAttribute('data-media-id');
//       if (!id) return;
//       [].forEach.call(thumbs, function (t) {
//         t.classList.toggle('selected', t.getAttribute('data-media-id') === id);
//       });
//     }
//     new MutationObserver(sync).observe(slideshow, { attributes: true, attributeFilter: ['class'], subtree: true });
//     sync();
//   })();

//   function log() {
//     console.log.apply(console, ['[HPO]'].concat([].slice.call(arguments)));
//   }

//   function tpl(name) {
//     var t = root.querySelector('template[data-hpo-tpl="' + name + '"]');
//     return t ? t.content.firstElementChild.cloneNode(true) : null;
//   }

//   function debounce(fn, ms) {
//     var t;
//     return function () {
//       var args = arguments;
//       clearTimeout(t);
//       t = setTimeout(function () { fn.apply(null, args); }, ms);
//     };
//   }

//   /* ---------- 1. waitForHulk ---------- */
//   function waitForHulk(timeoutMs) {
//     return new Promise(function (resolve, reject) {
//       function ok() {
//         return window.hulkapps && document.querySelector('.hulkapps_product_options .hulkapps_option');
//       }
//       if (ok()) return resolve();
//       var timer = setTimeout(function () {
//         mo.disconnect();
//         reject(new Error('Hulk app not detected within ' + timeoutMs + 'ms'));
//       }, timeoutMs);
//       var mo = new MutationObserver(function () {
//         if (ok()) {
//           mo.disconnect();
//           clearTimeout(timer);
//           resolve();
//         }
//       });
//       mo.observe(document.documentElement, { childList: true, subtree: true });
//     });
//   }

//   /* ---------- 2. fetchOptions ---------- */
//   function fetchOptions() {
//     if (window.HPO_FIXTURE) {
//       log('using window.HPO_FIXTURE override');
//       return Promise.resolve(window.HPO_FIXTURE);
//     }
//     // verified window.hulkapps keys: product_id, product{}, product_collections, store_id, po_url
//     var h = window.hulkapps || {};
//     var base = String(h.po_url || '').replace(/\/+$/, '');
//     if (!base) return Promise.reject(new Error('window.hulkapps.po_url missing'));
//     var params = new URLSearchParams();
//     params.set('hpage_type', 'product');
//     params.set('pid', String(h.pid || h.product_id || (h.product && h.product.id) || cfg.productId || ''));
//     params.set('store_id', String(h.store_id || ''));
//     params.set('tags', String(h.tags || (h.product && h.product.tags) || ''));
//     params.set('vendor', String(h.vendor || (h.product && h.product.vendor) || ''));
//     params.set('ptype', String(h.ptype || (h.product && h.product.type) || ''));
//     params.set('customer_tags', String(h.customer_tags || ''));
//     params.set('product_collections', String(h.product_collections || ''));
//     params.set('shopify_currency_rate', String(window.hulkapps_shopify_rate || h.shopify_currency_rate || 1));
//     return fetch(base + '/api/v2/store/get_all_relationships', { method: 'POST', body: params }).then(function (res) {
//       if (!res.ok) throw new Error('get_all_relationships HTTP ' + res.status);
//       return res.json();
//     });
//   }

//   function fetchDescriptions() {
//     if (!cfg.descriptionsUrl) return Promise.resolve({});
//     return fetch(cfg.descriptionsUrl)
//       .then(function (res) { return res.ok ? res.json() : {}; })
//       .catch(function () { return {}; });
//   }

//   /* ---------- 3. normalize ---------- */
//   function parseMaybeJson(v) {
//     if (typeof v !== 'string') return v;
//     try { return JSON.parse(v); } catch (e) { return null; }
//   }

//   // Haris edit: 
  
//   function flatten(list) {
//     var out = [];
//     (list || []).forEach(function (x) { out = out.concat(x); });
//     return out;
//   }

//   // OLD displayOrder() function
//   // function displayOrder(raw) {
//   //   var rel = raw.relationship && parseMaybeJson(raw.relationship.options);
//   //   var order = [];
//   //   if (rel && typeof rel === 'object') {
//   //     Object.keys(rel)
//   //       .map(Number)
//   //       .sort(function (a, b) { return a - b; })
//   //       .forEach(function (k) { order = order.concat(rel[k]); });
//   //   }
//   //   if (!order.length && Array.isArray(raw.relationship_option)) {
//   //     raw.relationship_option.forEach(function (x) { order = order.concat(x); });
//   //   }
//   //   if (!order.length && Array.isArray(raw.option_id_array)) order = raw.option_id_array;
//   //   return order.map(String);
//   // }

//   // NEW displayOrder() function

//   function displayOrder(raw) {
//     var rel = raw.relationship && parseMaybeJson(raw.relationship.options);
//     var slots = [];
//     if (rel && typeof rel === 'object') {
//       Object.keys(rel)
//         .map(Number)
//         .sort(function (a, b) { return a - b; })
//         .forEach(function (k) { slots = slots.concat(rel[k]); });
//     }
//     var order = Array.isArray(raw.relationship_option) ? flatten(raw.relationship_option) : [];
//     if (!order.length) {
//       order = slots;
//     } else {
//       // never drop an option the flat list fails to mention
//       var seen = {};
//       order.forEach(function (id) { seen[String(id)] = 1; });
//       slots.forEach(function (id) { if (!seen[String(id)]) order.push(id); });
//     }
//     if (!order.length && Array.isArray(raw.option_id_array)) order = raw.option_id_array;
//     return order.map(String);
//   }

//   /* Hulk delivers a value in one of two shapes:
//      - positional array (get_all_relationships today): [0] name, [1] price, [2] swatch_type,
//        [3] image URL / hex, [9] price mode, [13] weight
//      - object (v1/products; shape confirmed by Hulk on 2026-09-28 for the "Recommended option"
//        feature): option_val, option_price, swatch_type, swatch_val, option_title, charge_type,
//        recommended (bool), recommended_value (badge label, may be "")
//      Both are accepted so the badge works whichever shape the endpoint returns. Array shape,
//      verified live on 2026-09-28 after Hulk's deploy: the "Recommended option" checkbox is
//      [11] (true/false) and its label (recommended_value) is [15] (null/"" when empty → the
//      "Badge fallback text" setting is shown instead). */
//   function isTruthyFlag(x) {
//     return x === true || x === 1 || x === 'true' || x === '1';
//   }

//   function normalizeValue(v, descriptions) {
//     var f;
//     if (Array.isArray(v)) {
//       f = {
//         name: v[0], price: v[1], swatchType: v[2], swatchVal: v[3], priceMode: v[9],
//         recommended: v[11],
//         recommendedLabel: v.length > 15 && typeof v[15] === 'string' ? v[15] : ''
//       };
//     } else if (v && typeof v === 'object') {
//       f = {
//         name: v.option_val, price: v.option_price, swatchType: v.swatch_type, swatchVal: v.swatch_val,
//         priceMode: v.charge_type, recommended: v.recommended, recommendedLabel: v.recommended_value
//       };
//     } else {
//       return null;
//     }
//     var name = String(f.name == null ? '' : f.name);
//     var label = String(f.recommendedLabel == null ? '' : f.recommendedLabel).trim();
//     return {
//       value: name,
//       label: name.trim(),
//       price: f.price != null && f.price !== '' ? parseFloat(f.price) : null,
//       swatchType: f.swatchType || null,
//       image: f.swatchType === 'image' ? f.swatchVal : null,
//       color: f.swatchType === 'color' ? f.swatchVal : null,
//       priceMode: f.priceMode || null,
//       description: descriptions[name.trim()] || null,
//       // "Recommended option" checkbox in the Hulk admin → badge; its label falls back to the
//       // theme setting when the merchant left the label field empty
//       badge: isTruthyFlag(f.recommended) ? label || cfg.badgeLabel || null : null,
//       default: false
//     };
//   }

//   function normalize(raw, descriptions) {
//     var byId = raw.option_associative_array || {};
//     return displayOrder(raw)
//       .filter(function (id) { return byId[id]; })
//       .map(function (id) {
//         var opt = byId[id];
//         var ef = opt.extra_field || {};
//         var min = parseInt(ef.minimum_selection, 10) || 0;
//         var maxParsed = parseInt(ef.maximum_selection, 10);
//         // empty maximum_selection = no limit (multi-select without cap)
//         var max = isFinite(maxParsed) && maxParsed > 0 ? maxParsed : Infinity;
//         var valuesRaw = parseMaybeJson(opt.values_json) || [];
//         var isInfo = opt.option_type === 'information';
//         var values = isInfo ? [] : valuesRaw
//           .map(function (v) { return normalizeValue(v, descriptions); })
//           .filter(Boolean);
//         // "Information" option: the app injects value[2] as raw HTML (no input, never validated)
//         var first = valuesRaw[0];
//         var html = !isInfo || !first ? '' : Array.isArray(first) ? first[2] : first.swatch_type || first.option_title || '';
//         // "Keine …"-style reset sentinel of single-select extras: structurally the first value
//         // with no price and a plain color swatch (never matched by name)
//         var noneValue = values[0] && values[0].price == null && values[0].swatchType === 'color' ? values[0] : null;
//         return {
//           id: String(id),
//           name: String(opt.option_name || '').trim(),
//           type: opt.option_type,
//           min: min,
//           max: max,
//           required: min > 0,
//           placeholder: opt.placeholder || '',
//           noneValue: noneValue,
//           html: String(html || ''),
//           values: values
//         };
//       });
//   }

//   /* ---------- price formatting ---------- */
//   var nf = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   function fmtPrice(p, long) {
//     return '+ ' + nf.format(p) + ' € ' + (long ? 'pro Person' : 'p. P.');
//   }

//   /* ---------- 5. bridge (all selectors scoped inside .hulkapps_option[data-parent-id]) ---------- */
//   /* Hulk's DOM values append a price suffix to priced values ("Antipasti Platte [ €3.50 ]")
//      while the API values don't — compare via canon() and store API-canonical names only. */
//   function canon(s) {
//     return String(s == null ? '' : s)
//       .replace(/\s*\[\s*€[\d.,]+\s*\]\s*$/, '')
//       .replace(/\s+/g, ' ')
//       .trim();
//   }

//   var bridge = {
//     container: function (set) {
//       return document.querySelector('.hulkapps_option[data-parent-id="' + set.id + '"]');
//     },

//     /* swatch_multiple / swatch / checkbox / radio: input.swatch_checkbox mirrors */
//     findCheckbox: function (set, value) {
//       var box = bridge.container(set);
//       if (!box) return null;
//       var inputs = box.querySelectorAll('input.swatch_checkbox');
//       for (var i = 0; i < inputs.length; i++) {
//         if (canon(inputs[i].value) === canon(value)) return inputs[i];
//       }
//       return null;
//     },
//     setChecked: function (set, value, want) {
//       var input = bridge.findCheckbox(set, value);
//       if (!input) {
//         log('bridge: no hulk checkbox for', set.id, JSON.stringify(value));
//         return false;
//       }
//       if (Boolean(input.checked) !== Boolean(want)) {
//         (input.closest('.hulk_po_checkbox') || input).click();
//       }
//       return true;
//     },
//     checkedValues: function (set) {
//       var box = bridge.container(set);
//       if (!box) return null;
//       return [].slice
//         .call(box.querySelectorAll('input.swatch_checkbox:checked'))
//         .map(function (i) { return canon(i.value); });
//     },

//     /* color_image_dropdown / dropdown: ul.hulkapps_dd > li.dropdown_swatch[data-value],
//        selected li carries the class from data-val-selected-class ("dropdown_selected") */
//     ddItem: function (set, value) {
//       var box = bridge.container(set);
//       if (!box) return null;
//       var lis = box.querySelectorAll('ul.hulkapps_dd li.dropdown_swatch');
//       for (var i = 0; i < lis.length; i++) {
//         var dv = canon(lis[i].getAttribute('data-value'));
//         if (dv && dv === canon(value)) return lis[i];
//       }
//       return null;
//     },
//     ddSelect: function (set, value) {
//       var li = bridge.ddItem(set, value);
//       if (!li) {
//         log('bridge: no li.dropdown_swatch for', set.id, JSON.stringify(value));
//         return false;
//       }
//       li.click();
//       return true;
//     },
//     ddSelected: function (set) {
//       var box = bridge.container(set);
//       if (!box) return null;
//       var li = box.querySelector('ul.hulkapps_dd li.dropdown_swatch.dropdown_selected');
//       var v = li ? canon(li.getAttribute('data-value')) : '';
//       return v ? v : null;
//     },

//     /* textbox / textarea: set .value on the Hulk input, dispatch input + change */
//     textInput: function (set) {
//       var box = bridge.container(set);
//       if (!box) return null;
//       return box.querySelector('input.hulkapps_option_child[type="text"], textarea.hulkapps_option_child');
//     },
//     writeText: function (set, val) {
//       var input = bridge.textInput(set);
//       if (!input) {
//         log('bridge: no hulk text input for', set.id);
//         return false;
//       }
//       input.value = val;
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//       return true;
//     }
//   };

//   /* ---------- 4. render ---------- */
//   function fillCard(card, set, value) {
//     var input = card.querySelector('[data-slot="input"]');
//     var title = card.querySelector('[data-slot="title"]');
//     var desc = card.querySelector('[data-slot="desc"]');
//     var price = card.querySelector('[data-slot="price"]');
//     var media = card.querySelector('[data-slot="image"]');
//     var badge = card.querySelector('[data-slot="badge"]');
//     input.value = value.value;
//     input.name = 'hpo-' + set.id;
//     title.textContent = value.label;
//     if (desc && value.description) {
//       desc.textContent = value.description;
//       desc.hidden = false;
//     }
//     if (price && value.price != null && value.price > 0) {
//       price.textContent = fmtPrice(value.price);
//       price.hidden = false;
//     }
//     if (badge && value.badge) {
//       badge.textContent = value.badge;
//       badge.hidden = false;
//     }
//     if (media && value.image) {
//       var img = document.createElement('img');
//       img.src = value.image;
//       img.alt = '';
//       img.loading = 'lazy';
//       media.textContent = '';
//       media.appendChild(img);
//     }
//     return card;
//   }

//   function makeSetShell(set) {
//     var el = tpl('set');
//     el.dataset.hpoSetId = set.id;
//     el.querySelector('[data-slot="set-title"]').textContent = set.name;
//     var counter = el.querySelector('[data-slot="set-counter"]');
//     if (set.required) {
//       counter.hidden = false;
//       counter.textContent = '0/' + (isFinite(set.max) ? set.max : set.min);
//     } else {
//       el.classList.add('hpo-set--optional');
//       var row = el.querySelector('[data-slot="optional"]');
//       row.hidden = false;
//       row.querySelector('[data-slot="optional-label"]').textContent = cfg.optionalLabel;
//       row.querySelector('[data-slot="optional-hint"]').textContent = cfg.optionalHint;
//     }
//     return el;
//   }

//   /* swatch_multiple (multi) and swatch (single) share the card list */
//   function renderCards(set, multi) {
//     var el = makeSetShell(set);
//     var items = el.querySelector('[data-slot="items"]');
//     var tplName = multi ? 'swatch_multiple' : 'swatch';
//     set.values.forEach(function (value) {
//       var card = fillCard(tpl(tplName), set, value);
//       var input = card.querySelector('[data-slot="input"]');
//       if (!multi) input.type = 'checkbox'; // uncheck-on-second-click; single-select enforced below
//       input.addEventListener('change', function () {
//         onCardChange(set, value, input, multi);
//       });
//       items.appendChild(card);
//     });
//     return el;
//   }

//   /* checkbox (multi) / radio (single): plain rows, same change handling */
//   function renderChoices(set, multi) {
//     var el = makeSetShell(set);
//     var items = el.querySelector('[data-slot="items"]');
//     var tplName = multi ? 'checkbox' : 'radio';
//     set.values.forEach(function (value) {
//       var row = fillCard(tpl(tplName), set, value);
//       var input = row.querySelector('[data-slot="input"]');
//       if (!multi) input.type = 'checkbox';
//       input.addEventListener('change', function () {
//         onCardChange(set, value, input, multi);
//       });
//       items.appendChild(row);
//     });
//     return el;
//   }

//   /* dropdown: native select */
//   function renderDropdown(set) {
//     var el = makeSetShell(set);
//     var items = el.querySelector('[data-slot="items"]');
//     var field = tpl('dropdown');
//     field.querySelector('[data-slot="title"]').textContent = set.placeholder || '';
//     var select = field.querySelector('[data-slot="input"]');
//     var empty = document.createElement('option');
//     empty.value = '';
//     empty.textContent = set.placeholder || '—';
//     select.appendChild(empty);
//     set.values.forEach(function (value) {
//       var o = document.createElement('option');
//       o.value = value.value;
//       o.textContent = value.label + (value.price ? ' (' + fmtPrice(value.price) + ')' : '') + (value.badge ? ' · ' + value.badge : '');
//       select.appendChild(o);
//     });
//     select.addEventListener('change', function () {
//       if (select.value) bridge.ddSelect(set, select.value);
//       else if (set.noneValue) bridge.ddSelect(set, set.noneValue.value);
//       refreshSet(set);
//     });
//     items.appendChild(field);
//     return el;
//   }

//   /* textbox / textarea: mirror on input (debounced 150ms) + change */
//   function renderField(set) {
//     var el = makeSetShell(set);
//     var items = el.querySelector('[data-slot="items"]');
//     var field = tpl(set.type === 'textarea' ? 'textarea' : 'textbox');
//     field.querySelector('[data-slot="title"]').textContent = set.name;
//     // set name doubles as the heading — hide the duplicate bar title
//     el.querySelector('.hpo-set__bar').hidden = true;
//     var input = field.querySelector('[data-slot="input"]');
//     if (set.placeholder) input.placeholder = set.placeholder;
//     var mirror = function () { bridge.writeText(set, input.value); };
//     input.addEventListener('input', debounce(mirror, 150));
//     input.addEventListener('change', mirror);
//     items.appendChild(field);
//     return el;
//   }

//   /* color_image_dropdown: Figma "Extra …" accordion — SINGLE select per current data.
//      A second "+" replaces the first; clicking the selected item's "×" resets to the
//      "Keine …" sentinel (set.noneValue). TODO: when the merchant switches these options to a
//      multi-select type in the Hulk admin they render via the swatch_multiple path instead. */
//   function renderExtras(set) {
//     var el = tpl('extra') || tpl('color_image_dropdown');
//     el.dataset.hpoSetId = set.id;

//     var nameParts = set.name.split('|');
//     el.querySelector('[data-slot="set-title"]').textContent = nameParts[0].trim();
//     el.querySelector('[data-slot="optional-label"]').textContent = cfg.optionalLabel;
//     el.querySelector('[data-slot="optional-hint"]').textContent = cfg.extraHint;

//     var priceEl = el.querySelector('[data-slot="price"]');
//     var priced = set.values.filter(function (v) { return v.price != null && v.price > 0; });
//     set.commonPrice = priced.length && priced.every(function (v) { return v.price === priced[0].price; })
//       ? priced[0].price : null;
//     if (set.commonPrice != null) {
//       priceEl.textContent = fmtPrice(set.commonPrice, true);
//       priceEl.hidden = false;
//     }

//     var items = el.querySelector('[data-slot="items"]');
//     var toggle = el.querySelector('[data-slot="extra-toggle"]');
//     function setOpen(open) {
//       items.hidden = !open;
//       toggle.setAttribute('aria-expanded', String(open));
//     }
//     toggle.addEventListener('click', function () { setOpen(items.hidden); });
//     setOpen(cfg.extrasOpen);

//     set.values.forEach(function (value) {
//       if (set.noneValue && value === set.noneValue) return; // sentinel is not a card
//       var card = fillCard(tpl('swatch_multiple'), set, value);
//       var input = card.querySelector('[data-slot="input"]');
//       input.addEventListener('change', function () {
//         var want = input.checked;
//         if (want) {
//           bridge.ddSelect(set, value.value);
//         } else if (set.noneValue) {
//           bridge.ddSelect(set, set.noneValue.value); // "×" → reset to "Keine …"
//         }
//         refreshSet(set);
//       });
//       items.appendChild(card);
//     });
//     return el;
//   }

//   /* information: read-only HTML block the merchant wrote in the Hulk admin ("Gratis dazu" on
//      the grill buffets). The app injects it as raw HTML; we do the same minus scripts/handlers. */
//   function safeHtml(html) {
//     var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
//     [].slice.call(doc.querySelectorAll('script, iframe, object, embed, style')).forEach(function (n) { n.remove(); });
//     [].slice.call(doc.body.querySelectorAll('*')).forEach(function (n) {
//       [].slice.call(n.attributes).forEach(function (a) {
//         if (/^on/i.test(a.name) || /^\s*javascript:/i.test(a.value)) n.removeAttribute(a.name);
//       });
//     });
//     return doc.body.innerHTML;
//   }

//   function renderInfo(set) {
//     var el = tpl('information');
//     el.dataset.hpoSetId = set.id;
//     el.querySelector('[data-slot="desc"]').innerHTML = safeHtml(set.html);
//     return el;
//   }

//   function render(sets) {
//     els.sets.textContent = '';
//     els.notes.textContent = '';
//     sets.forEach(function (set) {
//       var el;
//       switch (set.type) {
//         case 'swatch_multiple': el = renderCards(set, true); break;
//         case 'swatch': el = renderCards(set, false); break;
//         case 'checkbox': el = renderChoices(set, true); break;
//         case 'radio': el = renderChoices(set, false); break;
//         case 'color_image_dropdown': el = renderExtras(set); break;
//         case 'dropdown': el = renderDropdown(set); break;
//         case 'textbox':
//         case 'textarea': el = renderField(set); break;
//         case 'information': el = renderInfo(set); break;
//         default:
//           // unknown type → leave the app's original render visible for it (see CLAUDE.md)
//           log('unknown option_type', set.type, '- no façade rendered for', set.id);
//           set.el = null;
//           return;
//       }
//       // design order: free-text sets (Anmerkungen) live after the guests block
//       if (set.type === 'textbox' || set.type === 'textarea') els.notes.appendChild(el);
//       else els.sets.appendChild(el);
//       set.el = el;
//     });
//   }

//   /* ---------- state / counters / disabled ---------- */
//   var CHECKBOX_TYPES = { swatch_multiple: 1, swatch: 1, checkbox: 1, radio: 1 };
//   var DROPDOWN_TYPES = { color_image_dropdown: 1, dropdown: 1 };

//   function refreshSet(set) {
//     if (!set.el) return;

//     if (CHECKBOX_TYPES[set.type]) {
//       var selected = bridge.checkedValues(set);
//       if (selected === null) selected = localSelection(set);
//       HPO.state.selections[set.id] = selected;
//       var count = selected.length;
//       var counter = set.el.querySelector('[data-slot="set-counter"]');
//       if (set.required && counter) {
//         counter.textContent = count + '/' + (isFinite(set.max) ? set.max : set.min);
//       } else if (counter) {
//         // optional card sets sum their selected prices in the counter slot — this is also
//         // the path future multi-select extras take, so sums keep working after the type switch
//         var hasPriced = set.values.some(function (v) { return v.price != null && v.price > 0; });
//         if (count > 0 && hasPriced) {
//           var sum = 0;
//           selected.forEach(function (sv) {
//             var v = set.values.filter(function (x) { return canon(x.value) === canon(sv); })[0];
//             sum += v && v.price != null ? v.price : 0;
//           });
//           counter.textContent = count + ' ' + cfg.extrasSelectedLabel + ' · ' + fmtPrice(sum, true);
//           counter.classList.add('hpo-set__counter--price');
//           counter.hidden = false;
//         } else {
//           counter.hidden = true;
//           counter.classList.remove('hpo-set__counter--price');
//         }
//       }
//       var single = set.type === 'swatch' || set.type === 'radio';
//       var full = single ? count >= 1 : isFinite(set.max) && count >= set.max;
//       var selectedKeys = selected.map(canon);
//       [].slice.call(set.el.querySelectorAll('[data-slot="card"]')).forEach(function (card) {
//         var input = card.querySelector('[data-slot="input"]');
//         if (!input) return;
//         var isSel = selectedKeys.indexOf(canon(input.value)) !== -1;
//         input.checked = isSel;
//         card.classList.toggle('is-selected', isSel);
//         card.classList.toggle('is-disabled', full && !isSel && !single);
//       });
//       refreshMenuItem(set, count);
//     } else if (DROPDOWN_TYPES[set.type]) {
//       var sel = bridge.ddSelected(set);
//       var isNone = set.noneValue && sel === set.noneValue.value;
//       var effective = sel && !isNone ? sel : null;
//       HPO.state.selections[set.id] = effective ? [effective] : [];
//       if (set.type === 'color_image_dropdown') {
//         var selValue = null;
//         [].slice.call(set.el.querySelectorAll('[data-slot="card"]')).forEach(function (card) {
//           var input = card.querySelector('[data-slot="input"]');
//           var isSel = effective !== null && canon(input.value) === canon(effective);
//           if (isSel) selValue = set.values.filter(function (v) { return canon(v.value) === canon(effective); })[0];
//           input.checked = isSel;
//           card.classList.toggle('is-selected', isSel);
//         });
//         // header summary: nothing → "+ 3,50 € pro Person"; N selected →
//         // "N ausgewählt · + {N × price} € pro Person" (works for future multi-select too)
//         var priceEl = set.el.querySelector('[data-slot="price"]');
//         if (priceEl) {
//           var picked = HPO.state.selections[set.id] || [];
//           if (picked.length) {
//             var total = 0;
//             picked.forEach(function (sv) {
//               var v = set.values.filter(function (x) { return canon(x.value) === canon(sv); })[0];
//               total += v && v.price != null ? v.price : set.commonPrice || 0;
//             });
//             priceEl.textContent = picked.length + ' ' + cfg.extrasSelectedLabel + ' · ' + fmtPrice(total, true);
//             priceEl.classList.add('hpo-extra__price--selected');
//             priceEl.hidden = false;
//           } else {
//             priceEl.classList.remove('hpo-extra__price--selected');
//             if (set.commonPrice != null) priceEl.textContent = fmtPrice(set.commonPrice, true);
//             else priceEl.hidden = true;
//           }
//         }
//       } else {
//         var select = set.el.querySelector('[data-slot="input"]');
//         if (select) select.value = effective || '';
//       }
//     }
//     refreshCta();
//   }

//   function localSelection(set) {
//     return [].slice
//       .call(set.el.querySelectorAll('[data-slot="input"]:checked'))
//       .map(function (i) { return i.value; });
//   }

//   function onCardChange(set, value, input, multi) {
//     var want = input.checked;
//     var current = HPO.state.selections[set.id] || [];
//     if (multi && want && isFinite(set.max) && current.length >= set.max) {
//       input.checked = false;
//       return;
//     }
//     if (!multi && want) {
//       // single-select: unpick the previous value first
//       current.forEach(function (v) {
//         if (canon(v) !== canon(value.value)) bridge.setChecked(set, v, false);
//       });
//     }
//     bridge.setChecked(set, value.value, want);
//     refreshSet(set);
//   }

//   /* ---------- FIX 2: scroll offset computed at click time ---------- */
//   /* Mode sets body{overflow-y:scroll}, which silently breaks every native smooth scroll in
//      Chrome (scrollTo/scrollIntoView with behavior:'smooth' are no-ops while instant scrolls
//      work). Hand-rolled rAF animation instead — no theme CSS touched. */
//   function smoothScrollTo(targetTop) {
//     var startTop = window.scrollY;
//     var delta = targetTop - startTop;
//     if (!delta) return;
//     var duration = Math.min(700, 250 + Math.abs(delta) * 0.05);
//     var start = null;
//     var cancelled = false;
//     function cancel() { cancelled = true; }
//     window.addEventListener('wheel', cancel, { once: true, passive: true });
//     window.addEventListener('touchstart', cancel, { once: true, passive: true });
//     function step(ts) {
//       if (cancelled) return;
//       if (start === null) start = ts;
//       var t = Math.min(1, (ts - start) / duration);
//       var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
//       window.scrollTo(0, startTop + delta * eased);
//       if (t < 1) requestAnimationFrame(step);
//     }
//     requestAnimationFrame(step);
//   }

//   function stickyHeaderHeight() {
//     var candidates = document.querySelectorAll(
//       'header, .header, #header, .site-header, .page-header, [data-section-type="header"], .section-header, .pageheader'
//     );
//     for (var i = 0; i < candidates.length; i++) {
//       var pos = getComputedStyle(candidates[i]).position;
//       if ((pos === 'sticky' || pos === 'fixed') && candidates[i].getBoundingClientRect().height > 0) {
//         return candidates[i].getBoundingClientRect().height;
//       }
//     }
//     return 0;
//   }

//   function menuIsSticky() {
//     return cfg.showMenu && !els.menu.hidden && els.menu.classList.contains('hpo-menu--sticky');
//   }

//   // bottom edge of the pinned menu — the line set headers stick to
//   function stickyBase() {
//     return stickyHeaderHeight() + (menuIsSticky() ? els.menu.getBoundingClientRect().height : 0);
//   }

//   function currentScrollOffset() {
//     // sticky menu → scroll targets land the set header EXACTLY in its stuck position
//     // (no extra padding — adding it would double-count now that the header is sticky);
//     // the "Zusätzlicher Abstand" setting only applies when the menu is not sticky
//     return menuIsSticky() ? stickyBase() : stickyHeaderHeight() + cfg.scrollOffset;
//   }

//   function applyScrollMargins() {
//     var off = currentScrollOffset();
//     root.style.setProperty('--hpo-menu-top', stickyHeaderHeight() + 'px');
//     root.style.setProperty('--hpo-sticky-offset', stickyBase() + 'px');
//     HPO.state.sets.forEach(function (set) {
//       if (set.el) set.el.style.scrollMarginTop = off + 'px';
//     });
//   }

//   /* ---------- 6. step menu ---------- */
//   var menuItems = {};
//   function buildMenu(sets) {
//     if (!cfg.showMenu) return;
//     var targets = sets.filter(function (s) { return s.min > 0; });
//     if (!targets.length) return;
//     targets.forEach(function (set) {
//       var item = tpl('menu-item');
//       var short = set.name.replace(/^Wähle\s+\d+\s+/i, '');
//       item.querySelector('[data-slot="title"]').textContent = short;
//       item.querySelector('[data-slot="set-counter"]').textContent = '0/' + (isFinite(set.max) ? set.max : set.min);
//       item.href = '#';
//       item.addEventListener('click', function (e) {
//         e.preventDefault();
//         smoothScrollTo(set.el.getBoundingClientRect().top + window.scrollY - currentScrollOffset());
//       });
//       els.menu.appendChild(item);
//       menuItems[set.id] = item;
//     });
//     els.menu.hidden = false;
//     var io = new IntersectionObserver(
//       function (entries) {
//         entries.forEach(function (entry) {
//           if (!entry.isIntersecting) return;
//           var id = entry.target.dataset.hpoSetId;
//           Object.keys(menuItems).forEach(function (k) {
//             menuItems[k].classList.toggle('is-active', k === id);
//           });
//         });
//       },
//       { rootMargin: '-' + Math.round(currentScrollOffset() + 40) + 'px 0px -60% 0px' }
//     );
//     targets.forEach(function (set) { io.observe(set.el); });
//   }

//   function refreshMenuItem(set, count) {
//     var item = menuItems[set.id];
//     if (!item) return;
//     item.querySelector('[data-slot="set-counter"]').textContent =
//       count + '/' + (isFinite(set.max) ? set.max : set.min);
//     // set reached its max (or min when unlimited) → green pill; .is-active still wins in CSS
//     item.classList.toggle('is-complete', count >= (isFinite(set.max) ? set.max : set.min));
//   }

//   /* ---------- 7. CTA ---------- */
//   function requiredSatisfied() {
//     return HPO.state.sets.every(function (set) {
//       if (!set.required || !set.el || set.hidden) return true; // hidden by a condition = not validated (same as the app)
//       return (HPO.state.selections[set.id] || []).length >= set.min;
//     });
//   }

//   function refreshCta() {
//     var ready = requiredSatisfied();
//     els.cta.disabled = !ready;
//     els.ctaLabel.textContent = ready ? cfg.ctaReady : cfg.ctaOpen;
//   }

//   function wireCta() {
//     refreshCta();
//     els.cta.addEventListener('click', function () {
//       if (els.cta.disabled) return;
//       var btn = document.querySelector('form.product-purchase-form button[name="add"]');
//       if (!btn) return log('CTA: button[name="add"] not found');
//       btn.click(); // the app intercepts the real submit; we never POST ourselves
//     });
//   }

//   /* ---------- 8. conditional logic — backup mirror of the app's show/hide ----------
//      Hulk evaluates its own "Conditional Logic" rules inside the hidden DOM: an option that is
//      currently hidden carries `conditional` (or `hulk_all_values_hidden`) on its .hulkapps_option,
//      and with enhanced rules single values carry `conditional` / `is_hulk_hide`. We never
//      evaluate rules ourselves — we only copy that visibility onto our sets/cards and skip hidden
//      sets in the CTA and step menu, exactly like the app skips them in validation. Without rules
//      (Relaxx today: condition[] is empty) nothing is ever marked, so this stays a no-op. */
//   var HULK_HIDDEN = '.conditional, .is_hulk_hide, .hulk_all_values_hidden';

//   function hulkValueHidden(set, box, value) {
//     var ctrl = CHECKBOX_TYPES[set.type] ? bridge.findCheckbox(set, value)
//       : DROPDOWN_TYPES[set.type] ? bridge.ddItem(set, value) : null;
//     for (var n = ctrl; n && n !== box; n = n.parentElement) {
//       if (n.matches(HULK_HIDDEN)) return true;
//     }
//     return false;
//   }

//   function syncConditional() {
//     if (!HPO.state) return;
//     var changed = false;
//     HPO.state.sets.forEach(function (set) {
//       if (!set.el) return;
//       var box = bridge.container(set);
//       var hidden = !!(box && box.matches(HULK_HIDDEN));
//       if (hidden !== !!set.hidden) {
//         set.hidden = hidden;
//         set.el.hidden = hidden;
//         set.el.classList.toggle('is-hidden', hidden);
//         if (menuItems[set.id]) menuItems[set.id].hidden = hidden;
//         changed = true;
//         log('conditional: set', set.id, hidden ? 'hidden' : 'shown', 'by the app');
//       }
//       // per-value rules: only walk the cards when the app marked something inside this option
//       var anyMarked = !!(box && box.querySelector(HULK_HIDDEN));
//       if (!anyMarked && !set.anyCardHidden) return;
//       var anyCardHidden = false;
//       [].slice.call(set.el.querySelectorAll('[data-slot="card"]')).forEach(function (card) {
//         var input = card.querySelector('[data-slot="input"]');
//         if (!input || input.tagName === 'SELECT' || input.type === 'text') return;
//         var valueHidden = anyMarked && hulkValueHidden(set, box, input.value);
//         if (valueHidden !== card.hidden) {
//           card.hidden = valueHidden;
//           changed = true;
//         }
//         anyCardHidden = anyCardHidden || valueHidden;
//       });
//       set.anyCardHidden = anyCardHidden;
//     });
//     if (changed) {
//       HPO.state.sets.forEach(refreshSet);
//       applyScrollMargins();
//     }
//   }

//   function watchConditional(raw) {
//     var container = document.querySelector('.hulkapps_product_options');
//     if (!container) return;
//     var rules = Array.isArray(raw.condition) ? raw.condition.length : 0;
//     var flagged = Object.keys(raw.hide_show_array || {}).length;
//     log('conditional rules:', rules, '· flagged options:', flagged, rules || flagged ? '→ mirroring app visibility' : '→ mirror idle');
//     new MutationObserver(debounce(syncConditional, 50)).observe(container, {
//       attributes: true,
//       attributeFilter: ['class'],
//       subtree: true
//     });
//     syncConditional();
//   }

//   /* ---------- guests = theme quantity ---------- */
//   function wireGuests() {
//     var input = root.querySelector('[data-hpo-guests-input]');
//     if (!input) return;
//     var minus = root.querySelector('[data-hpo-guests-minus]');
//     var plus = root.querySelector('[data-hpo-guests-plus]');
//     var qty =
//       document.querySelector('form.product-purchase-form input[name="quantity"]') ||
//       document.getElementById('quantity');

//     function apply(n) {
//       n = Math.max(cfg.guestsMin, Math.round(n / cfg.guestsStep) * cfg.guestsStep || cfg.guestsMin);
//       input.value = n;
//       HPO.state.guests = n;
//       minus.disabled = n <= cfg.guestsMin;
//       if (qty) {
//         qty.value = n;
//         qty.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//       [].slice.call(root.querySelectorAll('[data-hpo-guests-preset]')).forEach(function (b) {
//         b.classList.toggle('is-active', parseInt(b.value, 10) === n);
//       });
//     }
//     minus.addEventListener('click', function () { apply(parseInt(input.value, 10) - cfg.guestsStep); });
//     plus.addEventListener('click', function () { apply(parseInt(input.value, 10) + cfg.guestsStep); });
//     input.addEventListener('change', function () { apply(parseInt(input.value, 10) || cfg.guestsMin); });
//     [].slice.call(root.querySelectorAll('[data-hpo-guests-preset]')).forEach(function (b) {
//       b.addEventListener('click', function () { apply(parseInt(b.value, 10)); });
//     });
//     apply(parseInt(input.value, 10) || cfg.guestsMin);
//   }

//   /* ---------- boot ---------- */
//   waitForHulk(8000)
//     .then(function () {
//       return Promise.all([fetchOptions(), fetchDescriptions()]);
//     })
//     .then(function (results) {
//       HPO.raw = results[0];
//       var sets = normalize(results[0], results[1]);
//       if (!sets.length) throw new Error('normalize() produced 0 sets');
//       HPO.state = { sets: sets, selections: {}, guests: null };
//       render(sets);
//       buildMenu(sets);
//       wireGuests();
//       wireCta();
//       sets.forEach(refreshSet);
//       applyScrollMargins();
//       watchConditional(results[0]);
//       window.addEventListener('resize', debounce(applyScrollMargins, 200));
//       document.documentElement.classList.remove('hpo-pending');
//       document.documentElement.classList.add('hpo-ready');
//       document.body.classList.add('hpo-ready');
//       HPO.ready = true;
//       log('ready:', sets.length, 'sets rendered');
//     })
//     .catch(function (err) {
//       // fallback: drop pending WITHOUT ready → the original app UI becomes visible
//       document.documentElement.classList.remove('hpo-pending');
//       document.documentElement.classList.remove('hpo-ready');
//       document.body.classList.remove('hpo-ready');
//       var skeleton = root.querySelector('[data-hpo-skeleton]');
//       if (skeleton) skeleton.remove();
//       HPO.ready = false;
//       console.warn('[HPO] disabled, app UI stays visible:', err);
//     });
// })();

/* hpo-configurator.js — custom façade for Hulk Product Options (see CLAUDE.md).
   Pipeline: waitForHulk → fetchOptions → normalize → render → bridge → menu/guests/CTA →
   conditional mirror (hides sets/cards the app has hidden via its own Conditional Logic rules).
   The app's hidden DOM stays the source of truth; we mirror every interaction into it and
   re-read its state afterwards. `hpo-ready` is added to <body> only after a successful render;
   on any error it is removed so the app's original UI stays the customer-facing fallback. */
(function () {
  'use strict';

  var root = document.querySelector('[data-hpo-root]');
  if (!root) return;

  var cfg = {
    productId: root.dataset.productId,
    showMenu: root.dataset.showMenu === 'true',
    scrollOffset: parseInt(root.dataset.scrollOffset, 10) || 0, // extra padding, not the full offset
    extrasOpen: root.dataset.extrasOpen === 'true',
    optionalLabel: root.dataset.optionalLabel || 'OPTIONAL',
    optionalHint: root.dataset.optionalHint || '',
    extraHint: root.dataset.extraHint || '',
    extrasSelectedLabel: root.dataset.extrasSelectedLabel || 'ausgewählt',
    guestsMin: parseInt(root.dataset.guestsMin, 10) || 1,
    guestsStep: parseInt(root.dataset.guestsStep, 10) || 1,
    ctaOpen: root.dataset.ctaLabelOpen || '',
    ctaReady: root.dataset.ctaLabelReady || '',
    descriptionsUrl: root.dataset.descriptionsUrl || '',
    badgeLabel: root.dataset.badgeLabel || '',
    // Feedback 6.0: the button is active even while required sets are incomplete, unless the
    // merchant switches the gate back on in the theme editor
    ctaGate: root.dataset.ctaRequireComplete === 'true',
    // badge labels (from the Hulk admin) that get their own colors — see fillCard
    badgeA: (root.dataset.badgeALabel || '').trim(),
    badgeB: (root.dataset.badgeBLabel || '').trim()
  };

  /* ---------- upsell allow-list (2026-09) ----------
     Options the merchant switched from color_image_dropdown to a multi-select type but which
     must keep the compact Extras accordion (small cards, no description, "+" / "Ausgewählt ✓"
     pill, price summary in the header). PRESENTATION ONLY — required vs optional is still
     decided by minimum_selection alone, so this never touches validation or the cart.
     Exact-name match: no other swatch_multiple set ("Wähle N …", Saucen, Geschirr) can be
     caught by it. Override per template with data-upsell-options="Name A,Name B" on the root. */
  var UPSELL_NAMES = [
    'Extra Dessert multi',
    'Extra Vorspeise multi-swatch',
    'Extra Beilage multi',
    'Extra Beilage Spanferkel multi',
    'Einschulung Deluxe multi',
    'Extra Hauptspeise multi',
    'Extra Grillbeilage multi',
    'Extra Grillgericht multi',
    'Extra Frühstück Speise multi',
    'Extra Frühstück Teil multi',
    'Extra Fingerfood multi'
  ];

  function upsellKey(s) {
    return canon(String(s || '').split('|')[0]).toLowerCase();
  }
  var upsellKeys = {};
  (root.dataset.upsellOptions ? root.dataset.upsellOptions.split(',') : UPSELL_NAMES)
    .forEach(function (n) { upsellKeys[upsellKey(n)] = 1; });

  /* An option renders as the Extras accordion when it is still a color_image_dropdown, OR its
     admin name matches the allow-list in any field of the record (the "… multi" unique name
     is not option_name), OR it is optional AND its name carries the "| 3,50 €" upsell suffix.
     That last test is what catches "Extra Dessert | 4,20 €" after the type switch; the
     min === 0 guard means no required "Wähle N …" set can ever be caught by it, and Saucen /
     Geschirr / Anmerkungen carry no pipe, so they keep their current rendering. */
  function isUpsell(opt, min) {
    if (opt.option_type === 'color_image_dropdown') return true;
    for (var k in opt) {
      if (typeof opt[k] === 'string' && upsellKeys[upsellKey(opt[k])] === 1) return true;
    }
    return min === 0 && String(opt.option_name || '').indexOf('|') !== -1;
  }
  // admin-only markers in the option name ("… multi") must never reach the storefront
  function stripMarkers(s) {
    return String(s || '').replace(/[\s|·–-]*\b(multi[\s-]?swatch|multi)\b\s*$/i, '').trim();
  }

  var els = {
    sets: root.querySelector('[data-slot="sets"]'),
    notes: root.querySelector('[data-slot="notes"]'),
    menu: root.querySelector('[data-slot="menu"]'),
    cta: root.querySelector('[data-slot="cta"]'),
    ctaLabel: root.querySelector('[data-slot="cta-label"]')
  };

  var HPO = (window.HPO = { root: root, cfg: cfg, state: null, ready: false, raw: null });

  // the gallery lives outside [data-hpo-root], so copy the schema-driven vars up to the
  // shared .product-detail ancestor (CSS falls back to the defaults until this runs)
  var productDetail = root.closest('.product-detail');
  if (productDetail) {
    productDetail.style.setProperty('--hpo-image-radius', (parseInt(root.dataset.imageRadius, 10) || 12) + 'px');
    var accent = getComputedStyle(root).getPropertyValue('--hpo-accent').trim();
    if (accent) productDetail.style.setProperty('--hpo-accent', accent);
  }

  // Mode sets .selected on a thumbnail only when it is clicked — nothing is marked on load
  // and swiping the main image never updates it. Keep the thumbs in sync with slick's
  // current slide instead of reimplementing the carousel.
  (function wireGalleryActiveThumb() {
    var gallery = productDetail && productDetail.querySelector('.gallery');
    var slideshow = gallery && gallery.querySelector('.product-slideshow');
    var thumbs = gallery ? gallery.querySelectorAll('.thumbnail[data-media-id]') : [];
    if (!slideshow || !thumbs.length) return;
    function sync() {
      var cur = slideshow.querySelector('.slick-current');
      var id = cur && cur.getAttribute('data-media-id');
      if (!id) return;
      [].forEach.call(thumbs, function (t) {
        t.classList.toggle('selected', t.getAttribute('data-media-id') === id);
      });
    }
    new MutationObserver(sync).observe(slideshow, { attributes: true, attributeFilter: ['class'], subtree: true });
    sync();
  })();

  function log() {
    console.log.apply(console, ['[HPO]'].concat([].slice.call(arguments)));
  }

  function tpl(name) {
    var t = root.querySelector('template[data-hpo-tpl="' + name + '"]');
    return t ? t.content.firstElementChild.cloneNode(true) : null;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  /* ---------- 1. waitForHulk ---------- */
  function waitForHulk(timeoutMs) {
    return new Promise(function (resolve, reject) {
      function ok() {
        return window.hulkapps && document.querySelector('.hulkapps_product_options .hulkapps_option');
      }
      if (ok()) return resolve();
      var timer = setTimeout(function () {
        mo.disconnect();
        reject(new Error('Hulk app not detected within ' + timeoutMs + 'ms'));
      }, timeoutMs);
      var mo = new MutationObserver(function () {
        if (ok()) {
          mo.disconnect();
          clearTimeout(timer);
          resolve();
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    });
  }

  /* ---------- 2. fetchOptions ---------- */
  function fetchOptions() {
    if (window.HPO_FIXTURE) {
      log('using window.HPO_FIXTURE override');
      return Promise.resolve(window.HPO_FIXTURE);
    }
    // verified window.hulkapps keys: product_id, product{}, product_collections, store_id, po_url
    var h = window.hulkapps || {};
    var base = String(h.po_url || '').replace(/\/+$/, '');
    if (!base) return Promise.reject(new Error('window.hulkapps.po_url missing'));
    var params = new URLSearchParams();
    params.set('hpage_type', 'product');
    params.set('pid', String(h.pid || h.product_id || (h.product && h.product.id) || cfg.productId || ''));
    params.set('store_id', String(h.store_id || ''));
    params.set('tags', String(h.tags || (h.product && h.product.tags) || ''));
    params.set('vendor', String(h.vendor || (h.product && h.product.vendor) || ''));
    params.set('ptype', String(h.ptype || (h.product && h.product.type) || ''));
    params.set('customer_tags', String(h.customer_tags || ''));
    params.set('product_collections', String(h.product_collections || ''));
    params.set('shopify_currency_rate', String(window.hulkapps_shopify_rate || h.shopify_currency_rate || 1));
    return fetch(base + '/api/v2/store/get_all_relationships', { method: 'POST', body: params }).then(function (res) {
      if (!res.ok) throw new Error('get_all_relationships HTTP ' + res.status);
      return res.json();
    });
  }

  function fetchDescriptions() {
    if (!cfg.descriptionsUrl) return Promise.resolve({});
    return fetch(cfg.descriptionsUrl)
      .then(function (res) { return res.ok ? res.json() : {}; })
      .catch(function () { return {}; });
  }

  /* Per-value descriptions live in the Hulk admin as "Custom JS" (advanced_users.custom_js in
     the API response), one block per dish:
       if($.trim(mswatchTitle) == 'Name') { $('<div …>').html('<p>text</p>').insertAfter(…); }
     We read those name → text pairs straight from that script, so a dish added there shows
     its description here without touching the theme. hpo-descriptions.json (a one-time
     export of the same script) stays as the fallback for names the script does not mention. */
  function descriptionsFromCustomJs(raw) {
    var adv = raw && raw.advanced_users;
    if (typeof adv === 'string') adv = parseMaybeJson(adv);
    var js = String((adv && adv.custom_js) || (raw && raw.custom_js) || '');
    var out = {};
    var re = /\$\.trim\(mswatchTitle\)\s*==\s*(["'])(.*?)\1[^}]*?\.html\((["'])([\s\S]*?)\3\)/g;
    var m;
    while ((m = re.exec(js))) {
      var text = new DOMParser().parseFromString(m[4], 'text/html').body.textContent.replace(/\s+/g, ' ').trim();
      if (text) out[m[2].trim()] = text;
    }
    return out;
  }

  /* ---------- 3. normalize ---------- */
  function parseMaybeJson(v) {
    if (typeof v !== 'string') return v;
    try { return JSON.parse(v); } catch (e) { return null; }
  }

  function displayOrder(raw) {
    var rel = raw.relationship && parseMaybeJson(raw.relationship.options);
    var slots = [];
    if (rel && typeof rel === 'object') {
      Object.keys(rel)
        .map(Number)
        .sort(function (a, b) { return a - b; })
        .forEach(function (k) { slots = slots.concat(rel[k]); });
    }
    var order = [];
    if (Array.isArray(raw.relationship_option)) {
      raw.relationship_option.forEach(function (x) { order = order.concat(x); });
    }
    if (!order.length) {
      order = slots;
    } else {
      // never drop an option the flat list fails to mention
      var seen = {};
      order.forEach(function (id) { seen[String(id)] = 1; });
      slots.forEach(function (id) { if (!seen[String(id)]) order.push(id); });
    }
    if (!order.length && Array.isArray(raw.option_id_array)) order = raw.option_id_array;
    return order.map(String);
  }

  /* Hulk delivers a value in one of two shapes:
     - positional array (get_all_relationships today): [0] name, [1] price, [2] swatch_type,
       [3] image URL / hex, [9] price mode, [13] weight
     - object (v1/products; shape confirmed by Hulk on 2026-09-28 for the "Recommended option"
       feature): option_val, option_price, swatch_type, swatch_val, option_title, charge_type,
       recommended (bool), recommended_value (badge label, may be "")
     Both are accepted so the badge works whichever shape the endpoint returns. Array shape,
     verified live on 2026-09-28 after Hulk's deploy: the "Recommended option" checkbox is
     [11] (true/false) and its label (recommended_value) is [15] (null/"" when empty → the
     "Badge fallback text" setting is shown instead). */
  function isTruthyFlag(x) {
    return x === true || x === 1 || x === 'true' || x === '1';
  }

  function normalizeValue(v, descriptions) {
    var f;
    if (Array.isArray(v)) {
      f = {
        name: v[0], price: v[1], swatchType: v[2], swatchVal: v[3], priceMode: v[9],
        recommended: v[11],
        recommendedLabel: v.length > 15 && typeof v[15] === 'string' ? v[15] : ''
      };
    } else if (v && typeof v === 'object') {
      f = {
        name: v.option_val, price: v.option_price, swatchType: v.swatch_type, swatchVal: v.swatch_val,
        priceMode: v.charge_type, recommended: v.recommended, recommendedLabel: v.recommended_value
      };
    } else {
      return null;
    }
    var name = String(f.name == null ? '' : f.name);
    var label = String(f.recommendedLabel == null ? '' : f.recommendedLabel).trim();
    return {
      value: name,
      label: name.trim(),
      price: f.price != null && f.price !== '' ? parseFloat(f.price) : null,
      swatchType: f.swatchType || null,
      image: f.swatchType === 'image' ? f.swatchVal : null,
      color: f.swatchType === 'color' ? f.swatchVal : null,
      priceMode: f.priceMode || null,
      description: descriptions[name.trim()] || null,
      // "Recommended option" checkbox in the Hulk admin → badge; its label falls back to the
      // theme setting when the merchant left the label field empty
      badge: isTruthyFlag(f.recommended) ? label || cfg.badgeLabel || null : null,
      default: false
    };
  }

  function normalize(raw, descriptions) {
    var byId = raw.option_associative_array || {};
    return displayOrder(raw)
      .filter(function (id) { return byId[id]; })
      .map(function (id) {
        var opt = byId[id];
        var ef = opt.extra_field || {};
        var min = parseInt(ef.minimum_selection, 10) || 0;
        var maxParsed = parseInt(ef.maximum_selection, 10);
        // empty maximum_selection = no limit (multi-select without cap)
        var max = isFinite(maxParsed) && maxParsed > 0 ? maxParsed : Infinity;
        var valuesRaw = parseMaybeJson(opt.values_json) || [];
        var isInfo = opt.option_type === 'information';
        var values = isInfo ? [] : valuesRaw
          .map(function (v) { return normalizeValue(v, descriptions); })
          .filter(Boolean);
        // "Information" option: the app injects value[2] as raw HTML (no input, never validated)
        var first = valuesRaw[0];
        var html = !isInfo || !first ? '' : Array.isArray(first) ? first[2] : first.swatch_type || first.option_title || '';
        // "Keine …"-style reset sentinel of single-select extras: structurally the first value
        // with no price and a plain color swatch (never matched by name)
        var noneValue = values[0] && values[0].price == null && values[0].swatchType === 'color' ? values[0] : null;
        return {
          id: String(id),
          name: String(opt.option_name || '').trim(),
          type: opt.option_type,
          // renders as the Extras accordion: every color_image_dropdown, plus the multi-select
          // options on the allow-list above (see UPSELL_NAMES)
          upsell: isUpsell(opt, min),
          min: min,
          max: max,
          required: min > 0,
          placeholder: opt.placeholder || '',
          noneValue: noneValue,
          html: String(html || ''),
          values: values
        };
      });
  }

  /* ---------- price formatting ---------- */
  var nf = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function fmtPrice(p, long) {
    return '+ ' + nf.format(p) + ' € ' + (long ? 'pro Person' : 'p. P.');
  }

  /* ---------- 5. bridge (all selectors scoped inside .hulkapps_option[data-parent-id]) ---------- */
  /* Hulk's DOM values append a price suffix to priced values ("Antipasti Platte [ €3.50 ]")
     while the API values don't — compare via canon() and store API-canonical names only. */
  function canon(s) {
    return String(s == null ? '' : s)
      .replace(/\s*\[\s*€[\d.,]+\s*\]\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var bridge = {
    container: function (set) {
      return document.querySelector('.hulkapps_option[data-parent-id="' + set.id + '"]');
    },

    /* swatch_multiple / swatch / checkbox / radio: input.swatch_checkbox mirrors */
    findCheckbox: function (set, value) {
      var box = bridge.container(set);
      if (!box) return null;
      var inputs = box.querySelectorAll('input.swatch_checkbox');
      for (var i = 0; i < inputs.length; i++) {
        if (canon(inputs[i].value) === canon(value)) return inputs[i];
      }
      return null;
    },
    setChecked: function (set, value, want) {
      var input = bridge.findCheckbox(set, value);
      if (!input) {
        log('bridge: no hulk checkbox for', set.id, JSON.stringify(value));
        return false;
      }
      if (Boolean(input.checked) !== Boolean(want)) {
        (input.closest('.hulk_po_checkbox') || input).click();
      }
      return true;
    },
    checkedValues: function (set) {
      var box = bridge.container(set);
      if (!box) return null;
      return [].slice
        .call(box.querySelectorAll('input.swatch_checkbox:checked'))
        .map(function (i) { return canon(i.value); });
    },

    /* color_image_dropdown / dropdown: ul.hulkapps_dd > li.dropdown_swatch[data-value],
       selected li carries the class from data-val-selected-class ("dropdown_selected") */
    ddItem: function (set, value) {
      var box = bridge.container(set);
      if (!box) return null;
      var lis = box.querySelectorAll('ul.hulkapps_dd li.dropdown_swatch');
      for (var i = 0; i < lis.length; i++) {
        var dv = canon(lis[i].getAttribute('data-value'));
        if (dv && dv === canon(value)) return lis[i];
      }
      return null;
    },
    ddSelect: function (set, value) {
      var li = bridge.ddItem(set, value);
      if (!li) {
        log('bridge: no li.dropdown_swatch for', set.id, JSON.stringify(value));
        return false;
      }
      li.click();
      return true;
    },
    ddSelected: function (set) {
      var box = bridge.container(set);
      if (!box) return null;
      var li = box.querySelector('ul.hulkapps_dd li.dropdown_swatch.dropdown_selected');
      var v = li ? canon(li.getAttribute('data-value')) : '';
      return v ? v : null;
    },

    /* textbox / textarea: set .value on the Hulk input, dispatch input + change */
    textInput: function (set) {
      var box = bridge.container(set);
      if (!box) return null;
      return box.querySelector('input.hulkapps_option_child[type="text"], textarea.hulkapps_option_child');
    },
    writeText: function (set, val) {
      var input = bridge.textInput(set);
      if (!input) {
        log('bridge: no hulk text input for', set.id);
        return false;
      }
      input.value = val;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
  };

  /* ---------- 4. render ---------- */
  // badge label from the Hulk admin vs. a "Badge A/B label" setting: case-insensitive
  function sameLabel(a, b) {
    return !!b && String(a || '').trim().toLowerCase() === String(b).trim().toLowerCase();
  }

  function fillCard(card, set, value) {
    var input = card.querySelector('[data-slot="input"]');
    var title = card.querySelector('[data-slot="title"]');
    var desc = card.querySelector('[data-slot="desc"]');
    var price = card.querySelector('[data-slot="price"]');
    var media = card.querySelector('[data-slot="image"]');
    var badge = card.querySelector('[data-slot="badge"]');
    input.value = value.value;
    input.name = 'hpo-' + set.id;
    title.textContent = value.label;
    if (desc && value.description) {
      desc.textContent = value.description;
      desc.hidden = false;
    }
    if (price && value.price != null && value.price > 0) {
      price.textContent = fmtPrice(value.price);
      price.hidden = false;
    }
    if (badge && value.badge) {
      badge.textContent = value.badge;
      badge.classList.toggle('hpo-card__badge--a', sameLabel(value.badge, cfg.badgeA));
      badge.classList.toggle('hpo-card__badge--b', sameLabel(value.badge, cfg.badgeB));
      badge.hidden = false;
    }
    if (media && value.image) {
      var img = document.createElement('img');
      img.src = value.image;
      img.alt = '';
      img.loading = 'lazy';
      var ph = media.querySelector('.hpo-card__placeholder');
      if (ph) ph.remove();            // drop the cloche, keep the badge
      media.insertBefore(img, media.firstChild);
    }
    return card;
    
  }

  function makeSetShell(set) {
    var el = tpl('set');
    el.dataset.hpoSetId = set.id;
    el.querySelector('[data-slot="set-title"]').textContent = set.name;
    var counter = el.querySelector('[data-slot="set-counter"]');
    if (set.required) {
      counter.hidden = false;
      counter.textContent = '0/' + (isFinite(set.max) ? set.max : set.min);
    } else {
      el.classList.add('hpo-set--optional');
      var row = el.querySelector('[data-slot="optional"]');
      row.hidden = false;
      row.querySelector('[data-slot="optional-label"]').textContent = cfg.optionalLabel;
      row.querySelector('[data-slot="optional-hint"]').textContent = cfg.optionalHint;
    }
    return el;
  }

  /* swatch_multiple (multi) and swatch (single) share the card list */
  function renderCards(set, multi) {
    var el = makeSetShell(set);
    var items = el.querySelector('[data-slot="items"]');
    var tplName = multi ? 'swatch_multiple' : 'swatch';
    set.values.forEach(function (value) {
      var card = fillCard(tpl(tplName), set, value);
      var input = card.querySelector('[data-slot="input"]');
      if (!multi) input.type = 'checkbox'; // uncheck-on-second-click; single-select enforced below
      input.addEventListener('change', function () {
        onCardChange(set, value, input, multi);
      });
      items.appendChild(card);
    });
    return el;
  }

  /* checkbox (multi) / radio (single): plain rows, same change handling */
  function renderChoices(set, multi) {
    var el = makeSetShell(set);
    var items = el.querySelector('[data-slot="items"]');
    var tplName = multi ? 'checkbox' : 'radio';
    set.values.forEach(function (value) {
      var row = fillCard(tpl(tplName), set, value);
      var input = row.querySelector('[data-slot="input"]');
      if (!multi) input.type = 'checkbox';
      input.addEventListener('change', function () {
        onCardChange(set, value, input, multi);
      });
      items.appendChild(row);
    });
    return el;
  }

  /* dropdown: native select */
  function renderDropdown(set) {
    var el = makeSetShell(set);
    var items = el.querySelector('[data-slot="items"]');
    var field = tpl('dropdown');
    field.querySelector('[data-slot="title"]').textContent = set.placeholder || '';
    var select = field.querySelector('[data-slot="input"]');
    var empty = document.createElement('option');
    empty.value = '';
    empty.textContent = set.placeholder || '—';
    select.appendChild(empty);
    set.values.forEach(function (value) {
      var o = document.createElement('option');
      o.value = value.value;
      o.textContent = value.label + (value.price ? ' (' + fmtPrice(value.price) + ')' : '') + (value.badge ? ' · ' + value.badge : '');
      select.appendChild(o);
    });
    select.addEventListener('change', function () {
      if (select.value) bridge.ddSelect(set, select.value);
      else if (set.noneValue) bridge.ddSelect(set, set.noneValue.value);
      refreshSet(set);
    });
    items.appendChild(field);
    return el;
  }

  /* textbox / textarea: mirror on input (debounced 150ms) + change */
  function renderField(set) {
    var el = makeSetShell(set);
    var items = el.querySelector('[data-slot="items"]');
    var field = tpl(set.type === 'textarea' ? 'textarea' : 'textbox');
    field.querySelector('[data-slot="title"]').textContent = set.name;
    // set name doubles as the heading — hide the duplicate bar title
    el.querySelector('.hpo-set__bar').hidden = true;
    var input = field.querySelector('[data-slot="input"]');
    if (set.placeholder) input.placeholder = set.placeholder;
    var mirror = function () { bridge.writeText(set, input.value); };
    input.addEventListener('input', debounce(mirror, 150));
    input.addEventListener('change', mirror);
    items.appendChild(field);
    return el;
  }

  /* Extras accordion (Figma "Extra …"). Two data shapes land here:
     - color_image_dropdown: SINGLE select. A second "+" replaces the first; clicking the
       selected item's "×" resets to the "Keine …" sentinel (set.noneValue).
     - multi-select types on the UPSELL_NAMES allow-list (2026-09): several dishes at once,
       mirrored through the checkbox bridge exactly like any other swatch_multiple set.
     The markup and every .hpo-extra CSS rule are shared by both. */
  function renderExtras(set) {
    var el = tpl('extra') || tpl('color_image_dropdown');
    el.dataset.hpoSetId = set.id;

    var nameParts = set.name.split('|');
    el.querySelector('[data-slot="set-title"]').textContent = stripMarkers(nameParts[0]);
    el.querySelector('[data-slot="optional-label"]').textContent = cfg.optionalLabel;
    el.querySelector('[data-slot="optional-hint"]').textContent = cfg.extraHint;

    var priceEl = el.querySelector('[data-slot="price"]');
    var priced = set.values.filter(function (v) { return v.price != null && v.price > 0; });
    set.commonPrice = priced.length && priced.every(function (v) { return v.price === priced[0].price; })
      ? priced[0].price : null;
    if (set.commonPrice != null) {
      priceEl.textContent = fmtPrice(set.commonPrice, true);
      priceEl.hidden = false;
    }

    var items = el.querySelector('[data-slot="items"]');
    var toggle = el.querySelector('[data-slot="extra-toggle"]');
    function setOpen(open) {
      items.hidden = !open;
      el.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
    // the whole panel is the click target, not just the arrow: collapsed → any click opens
    // it; open → only the header closes it, so a click between the dishes never collapses it
    var head = toggle.closest('.hpo-extra__head') || toggle;
    el.addEventListener('click', function (e) {
      if (items.contains(e.target)) return;
      if (!items.hidden && !head.contains(e.target)) return;
      setOpen(items.hidden);
    });
    setOpen(cfg.extrasOpen);

    var isDd = DROPDOWN_TYPES[set.type];
    set.values.forEach(function (value) {
      // the "Keine …" reset entry is no card in the single-select dropdown shape (the "×"
      // resets to it); in a multi-select set it stays a visible, exclusive choice (noneKey)
      if (isDd && set.noneValue && value === set.noneValue) return;
      var card = fillCard(tpl('swatch_multiple'), set, value);
      // compact rows: the badge strip has no room on the 32px image tile → inline after the title
      var badgeEl = card.querySelector('[data-slot="badge"]');
      if (badgeEl && !badgeEl.hidden) card.querySelector('[data-slot="title"]').insertAdjacentElement('afterend', badgeEl);
      var input = card.querySelector('[data-slot="input"]');
      input.addEventListener('change', function () {
        if (!isDd) return onCardChange(set, value, input, true);
        if (input.checked) bridge.ddSelect(set, value.value);
        else if (set.noneValue) bridge.ddSelect(set, set.noneValue.value); // "×" → "Keine …"
        refreshSet(set);
      });
      items.appendChild(card);
    });
    return el;
  }

  /* information: read-only HTML block the merchant wrote in the Hulk admin ("Gratis dazu" on
     the grill buffets). The app injects it as raw HTML; we do the same minus scripts/handlers. */
  function safeHtml(html) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    [].slice.call(doc.querySelectorAll('script, iframe, object, embed, style')).forEach(function (n) { n.remove(); });
    [].slice.call(doc.body.querySelectorAll('*')).forEach(function (n) {
      [].slice.call(n.attributes).forEach(function (a) {
        if (/^on/i.test(a.name) || /^\s*javascript:/i.test(a.value)) n.removeAttribute(a.name);
      });
    });
    return doc.body.innerHTML;
  }

  function renderInfo(set) {
    var el = tpl('information');
    el.dataset.hpoSetId = set.id;
    el.querySelector('[data-slot="desc"]').innerHTML = safeHtml(set.html);
    return el;
  }

  function render(sets) {
    els.sets.textContent = '';
    els.notes.textContent = '';
    sets.forEach(function (set) {
      var el;
      // allow-listed multi-select upsells take the Extras accordion instead of the card list
      if (set.upsell && CHECKBOX_TYPES[set.type]) {
        el = renderExtras(set);
        els.sets.appendChild(el);
        set.el = el;
        return;
      }
      switch (set.type) {
        case 'swatch_multiple': el = renderCards(set, true); break;
        case 'swatch': el = renderCards(set, false); break;
        case 'checkbox': el = renderChoices(set, true); break;
        case 'radio': el = renderChoices(set, false); break;
        case 'color_image_dropdown': el = renderExtras(set); break;
        case 'dropdown': el = renderDropdown(set); break;
        case 'textbox':
        case 'textarea': el = renderField(set); break;
        case 'information': el = renderInfo(set); break;
        default:
          // unknown type → leave the app's original render visible for it (see CLAUDE.md)
          log('unknown option_type', set.type, '- no façade rendered for', set.id);
          set.el = null;
          return;
      }
      // design order: free-text sets (Anmerkungen) live after the guests block
      if (set.type === 'textbox' || set.type === 'textarea') els.notes.appendChild(el);
      else els.sets.appendChild(el);
      set.el = el;
    });
  }

  /* ---------- state / counters / disabled ---------- */
  var CHECKBOX_TYPES = { swatch_multiple: 1, swatch: 1, checkbox: 1, radio: 1 };
  var DROPDOWN_TYPES = { color_image_dropdown: 1, dropdown: 1 };

  /* "Keine extra …" entry of an Extras accordion that became multi-select: still the first,
     price-less colour-swatch value (set.noneValue), but now a real checkbox next to the
     dishes. It is exclusive — picking it unpicks and locks the dishes of that set — and it
     never counts as a paid extra in the header. null for every other set. */
  function noneKey(set) {
    return set.upsell && CHECKBOX_TYPES[set.type] && set.noneValue ? canon(set.noneValue.value) : null;
  }

  /* Extras header summary: "+ 3,50 € pro Person" with nothing picked, "N ausgewählt ·
     + {sum} € pro Person" afterwards. Shared by both shapes that render as an accordion. */
  function refreshExtraHeader(set) {
    var priceEl = set.el && set.el.querySelector('[data-slot="price"]');
    if (!priceEl) return;
    var none = noneKey(set);
    var picked = (HPO.state.selections[set.id] || []).filter(function (sv) { return canon(sv) !== none; });
    if (picked.length) {
      var total = 0;
      picked.forEach(function (sv) {
        var v = set.values.filter(function (x) { return canon(x.value) === canon(sv); })[0];
        total += v && v.price != null ? v.price : set.commonPrice || 0;
      });
      priceEl.textContent = picked.length + ' ' + cfg.extrasSelectedLabel + ' · ' + fmtPrice(total, true);
      priceEl.classList.add('hpo-extra__price--selected');
      priceEl.hidden = false;
    } else {
      priceEl.classList.remove('hpo-extra__price--selected');
      if (set.commonPrice != null) {
        priceEl.textContent = fmtPrice(set.commonPrice, true);
        priceEl.hidden = false;
      } else {
        priceEl.hidden = true;
      }
    }
  }

  function refreshSet(set) {
    if (!set.el) return;

    if (CHECKBOX_TYPES[set.type]) {
      var selected = bridge.checkedValues(set);
      if (selected === null) selected = localSelection(set);
      HPO.state.selections[set.id] = selected;
      var count = selected.length;
      var counter = set.el.querySelector('[data-slot="set-counter"]');
      if (set.required && counter) {
        counter.textContent = count + '/' + (isFinite(set.max) ? set.max : set.min);
      } else if (counter) {
        // optional card sets sum their selected prices in the counter slot — this is also
        // the path future multi-select extras take, so sums keep working after the type switch
        var hasPriced = set.values.some(function (v) { return v.price != null && v.price > 0; });
        if (count > 0 && hasPriced) {
          var sum = 0;
          selected.forEach(function (sv) {
            var v = set.values.filter(function (x) { return canon(x.value) === canon(sv); })[0];
            sum += v && v.price != null ? v.price : 0;
          });
          counter.textContent = count + ' ' + cfg.extrasSelectedLabel + ' · ' + fmtPrice(sum, true);
          counter.classList.add('hpo-set__counter--price');
          counter.hidden = false;
        } else {
          counter.hidden = true;
          counter.classList.remove('hpo-set__counter--price');
        }
      }
      var single = set.type === 'swatch' || set.type === 'radio';
      var full = single ? count >= 1 : isFinite(set.max) && count >= set.max;
      var selectedKeys = selected.map(canon);
      var none = noneKey(set);
      var locked = none !== null && selectedKeys.indexOf(none) !== -1; // "Keine …" is picked
      [].slice.call(set.el.querySelectorAll('[data-slot="card"]')).forEach(function (card) {
        var input = card.querySelector('[data-slot="input"]');
        if (!input) return;
        var isSel = selectedKeys.indexOf(canon(input.value)) !== -1;
        input.checked = isSel;
        card.classList.toggle('is-selected', isSel);
        card.classList.toggle('is-disabled', (full && !isSel && !single) || (locked && !isSel));
      });
      refreshMenuItem(set, count);
      // allow-listed upsells render as an accordion: keep its header summary in sync too
      if (set.upsell) refreshExtraHeader(set);
    } else if (DROPDOWN_TYPES[set.type]) {
      var sel = bridge.ddSelected(set);
      var isNone = set.noneValue && sel === set.noneValue.value;
      var effective = sel && !isNone ? sel : null;
      HPO.state.selections[set.id] = effective ? [effective] : [];
      if (set.type === 'color_image_dropdown') {
        [].slice.call(set.el.querySelectorAll('[data-slot="card"]')).forEach(function (card) {
          var input = card.querySelector('[data-slot="input"]');
          var isSel = effective !== null && canon(input.value) === canon(effective);
          input.checked = isSel;
          card.classList.toggle('is-selected', isSel);
        });
        refreshExtraHeader(set);
      } else {
        var select = set.el.querySelector('[data-slot="input"]');
        if (select) select.value = effective || '';
      }
    }
    refreshCta();
  }

  function localSelection(set) {
    return [].slice
      .call(set.el.querySelectorAll('[data-slot="input"]:checked'))
      .map(function (i) { return i.value; });
  }

  function onCardChange(set, value, input, multi) {
    var want = input.checked;
    var current = HPO.state.selections[set.id] || [];
    var none = noneKey(set);
    var pickingNone = want && none !== null && canon(value.value) === none;
    if (want && none !== null && !pickingNone && current.map(canon).indexOf(none) !== -1) {
      // "Keine …" is picked → the dishes of this set stay locked (their cards are disabled too)
      input.checked = false;
      return;
    }
    if (multi && want && !pickingNone && isFinite(set.max) && current.length >= set.max) {
      input.checked = false;
      return;
    }
    if ((!multi || pickingNone) && want) {
      // single-select, or "Keine …" on a multi-select extra: unpick everything else first
      current.forEach(function (v) {
        if (canon(v) !== canon(value.value)) bridge.setChecked(set, v, false);
      });
    }
    bridge.setChecked(set, value.value, want);
    refreshSet(set);
  }

  /* ---------- FIX 2: scroll offset computed at click time ---------- */
  /* Mode sets body{overflow-y:scroll}, which silently breaks every native smooth scroll in
     Chrome (scrollTo/scrollIntoView with behavior:'smooth' are no-ops while instant scrolls
     work). Hand-rolled rAF animation instead — no theme CSS touched. */
  function smoothScrollTo(targetTop) {
    var startTop = window.scrollY;
    var delta = targetTop - startTop;
    if (!delta) return;
    var duration = Math.min(700, 250 + Math.abs(delta) * 0.05);
    var start = null;
    var cancelled = false;
    function cancel() { cancelled = true; }
    window.addEventListener('wheel', cancel, { once: true, passive: true });
    window.addEventListener('touchstart', cancel, { once: true, passive: true });
    function step(ts) {
      if (cancelled) return;
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      window.scrollTo(0, startTop + delta * eased);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function stickyHeaderHeight() {
    var candidates = document.querySelectorAll(
      'header, .header, #header, .site-header, .page-header, [data-section-type="header"], .section-header, .pageheader'
    );
    for (var i = 0; i < candidates.length; i++) {
      var pos = getComputedStyle(candidates[i]).position;
      if ((pos === 'sticky' || pos === 'fixed') && candidates[i].getBoundingClientRect().height > 0) {
        return candidates[i].getBoundingClientRect().height;
      }
    }
    return 0;
  }

  function menuIsSticky() {
    return cfg.showMenu && !els.menu.hidden && els.menu.classList.contains('hpo-menu--sticky');
  }

  // bottom edge of the pinned menu — the line set headers stick to
  function stickyBase() {
    return stickyHeaderHeight() + (menuIsSticky() ? els.menu.getBoundingClientRect().height : 0);
  }

  function currentScrollOffset() {
    // sticky menu → scroll targets land the set header EXACTLY in its stuck position
    // (no extra padding — adding it would double-count now that the header is sticky);
    // the "Zusätzlicher Abstand" setting only applies when the menu is not sticky
    return menuIsSticky() ? stickyBase() : stickyHeaderHeight() + cfg.scrollOffset;
  }

  function applyScrollMargins() {
    var off = currentScrollOffset();
    root.style.setProperty('--hpo-menu-top', stickyHeaderHeight() + 'px');
    root.style.setProperty('--hpo-sticky-offset', stickyBase() + 'px');
    HPO.state.sets.forEach(function (set) {
      if (set.el) set.el.style.scrollMarginTop = off + 'px';
    });
  }

  /* ---------- 6. step menu ---------- */
  var menuItems = {};
  function buildMenu(sets) {
    if (!cfg.showMenu) return;
    var targets = sets.filter(function (s) { return s.min > 0; });
    if (!targets.length) return;
    targets.forEach(function (set) {
      var item = tpl('menu-item');
      var short = set.name.replace(/^Wähle\s+\d+\s+/i, '');
      item.querySelector('[data-slot="title"]').textContent = short;
      item.querySelector('[data-slot="set-counter"]').textContent = '0/' + (isFinite(set.max) ? set.max : set.min);
      item.href = '#';
      item.addEventListener('click', function (e) {
        e.preventDefault();
        smoothScrollTo(set.el.getBoundingClientRect().top + window.scrollY - currentScrollOffset());
      });
      els.menu.appendChild(item);
      menuItems[set.id] = item;
    });
    els.menu.hidden = false;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.dataset.hpoSetId;
          Object.keys(menuItems).forEach(function (k) {
            menuItems[k].classList.toggle('is-active', k === id);
          });
        });
      },
      { rootMargin: '-' + Math.round(currentScrollOffset() + 40) + 'px 0px -60% 0px' }
    );
    targets.forEach(function (set) { io.observe(set.el); });
  }

  function refreshMenuItem(set, count) {
    var item = menuItems[set.id];
    if (!item) return;
    item.querySelector('[data-slot="set-counter"]').textContent =
      count + '/' + (isFinite(set.max) ? set.max : set.min);
    // set reached its max (or min when unlimited) → green pill; .is-active still wins in CSS
    item.classList.toggle('is-complete', count >= (isFinite(set.max) ? set.max : set.min));
  }

  /* ---------- 7. CTA ---------- */
  function requiredSatisfied() {
    return HPO.state.sets.every(function (set) {
      if (!set.required || !set.el || set.hidden) return true; // hidden by a condition = not validated (same as the app)
      return (HPO.state.selections[set.id] || []).length >= set.min;
    });
  }

  function refreshCta() {
    var ready = requiredSatisfied();
    els.cta.disabled = cfg.ctaGate && !ready;
    els.ctaLabel.textContent = ready ? cfg.ctaReady : cfg.ctaOpen;
  }

  function wireCta() {
    refreshCta();
    els.cta.addEventListener('click', function () {
      if (els.cta.disabled) return;
      var btn = document.querySelector('form.product-purchase-form button[name="add"]');
      if (!btn) return log('CTA: button[name="add"] not found');
      btn.click(); // the app intercepts the real submit; we never POST ourselves
    });
  }

  /* ---------- 8. conditional logic — backup mirror of the app's show/hide ----------
     Hulk evaluates its own "Conditional Logic" rules inside the hidden DOM: an option that is
     currently hidden carries `conditional` (or `hulk_all_values_hidden`) on its .hulkapps_option,
     and with enhanced rules single values carry `conditional` / `is_hulk_hide`. We never
     evaluate rules ourselves — we only copy that visibility onto our sets/cards and skip hidden
     sets in the CTA and step menu, exactly like the app skips them in validation. Without rules
     (Relaxx today: condition[] is empty) nothing is ever marked, so this stays a no-op. */
  var HULK_HIDDEN = '.conditional, .is_hulk_hide, .hulk_all_values_hidden';

  function hulkValueHidden(set, box, value) {
    var ctrl = CHECKBOX_TYPES[set.type] ? bridge.findCheckbox(set, value)
      : DROPDOWN_TYPES[set.type] ? bridge.ddItem(set, value) : null;
    for (var n = ctrl; n && n !== box; n = n.parentElement) {
      if (n.matches(HULK_HIDDEN)) return true;
    }
    return false;
  }

  function syncConditional() {
    if (!HPO.state) return;
    var changed = false;
    HPO.state.sets.forEach(function (set) {
      if (!set.el) return;
      var box = bridge.container(set);
      var hidden = !!(box && box.matches(HULK_HIDDEN));
      if (hidden !== !!set.hidden) {
        set.hidden = hidden;
        set.el.hidden = hidden;
        set.el.classList.toggle('is-hidden', hidden);
        if (menuItems[set.id]) menuItems[set.id].hidden = hidden;
        changed = true;
        log('conditional: set', set.id, hidden ? 'hidden' : 'shown', 'by the app');
      }
      // per-value rules: only walk the cards when the app marked something inside this option
      var anyMarked = !!(box && box.querySelector(HULK_HIDDEN));
      if (!anyMarked && !set.anyCardHidden) return;
      var anyCardHidden = false;
      [].slice.call(set.el.querySelectorAll('[data-slot="card"]')).forEach(function (card) {
        var input = card.querySelector('[data-slot="input"]');
        if (!input || input.tagName === 'SELECT' || input.type === 'text') return;
        var valueHidden = anyMarked && hulkValueHidden(set, box, input.value);
        if (valueHidden !== card.hidden) {
          card.hidden = valueHidden;
          changed = true;
        }
        anyCardHidden = anyCardHidden || valueHidden;
      });
      set.anyCardHidden = anyCardHidden;
    });
    if (changed) {
      HPO.state.sets.forEach(refreshSet);
      applyScrollMargins();
    }
  }

  function watchConditional(raw) {
    var container = document.querySelector('.hulkapps_product_options');
    if (!container) return;
    var rules = Array.isArray(raw.condition) ? raw.condition.length : 0;
    var flagged = Object.keys(raw.hide_show_array || {}).length;
    log('conditional rules:', rules, '· flagged options:', flagged, rules || flagged ? '→ mirroring app visibility' : '→ mirror idle');
    new MutationObserver(debounce(syncConditional, 50)).observe(container, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
    syncConditional();
  }

  /* ---------- guests = theme quantity ---------- */
  function wireGuests() {
    var input = root.querySelector('[data-hpo-guests-input]');
    if (!input) return;
    var minus = root.querySelector('[data-hpo-guests-minus]');
    var plus = root.querySelector('[data-hpo-guests-plus]');
    var qty =
      document.querySelector('form.product-purchase-form input[name="quantity"]') ||
      document.getElementById('quantity');

    function apply(n) {
      n = Math.max(cfg.guestsMin, Math.round(n / cfg.guestsStep) * cfg.guestsStep || cfg.guestsMin);
      input.value = n;
      HPO.state.guests = n;
      minus.disabled = n <= cfg.guestsMin;
      if (qty) {
        qty.value = n;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      [].slice.call(root.querySelectorAll('[data-hpo-guests-preset]')).forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.value, 10) === n);
      });
    }
    minus.addEventListener('click', function () { apply(parseInt(input.value, 10) - cfg.guestsStep); });
    plus.addEventListener('click', function () { apply(parseInt(input.value, 10) + cfg.guestsStep); });
    input.addEventListener('change', function () { apply(parseInt(input.value, 10) || cfg.guestsMin); });
    [].slice.call(root.querySelectorAll('[data-hpo-guests-preset]')).forEach(function (b) {
      b.addEventListener('click', function () { apply(parseInt(b.value, 10)); });
    });
    apply(parseInt(input.value, 10) || cfg.guestsMin);
  }

  /* ---------- boot ---------- */
  waitForHulk(8000)
    .then(function () {
      return Promise.all([fetchOptions(), fetchDescriptions()]);
    })
    .then(function (results) {
      HPO.raw = results[0];
      // the admin script wins over the JSON export for names present in both
      var descriptions = Object.assign({}, results[1], descriptionsFromCustomJs(results[0]));
      var sets = normalize(results[0], descriptions);
      if (!sets.length) throw new Error('normalize() produced 0 sets');
      HPO.state = { sets: sets, selections: {}, guests: null };
      render(sets);
      buildMenu(sets);
      wireGuests();
      wireCta();
      sets.forEach(refreshSet);
      applyScrollMargins();
      watchConditional(results[0]);
      window.addEventListener('resize', debounce(applyScrollMargins, 200));
      document.documentElement.classList.remove('hpo-pending');
      document.documentElement.classList.add('hpo-ready');
      document.body.classList.add('hpo-ready');
      HPO.ready = true;
      log('ready:', sets.length, 'sets rendered');
    })
    .catch(function (err) {
      // fallback: drop pending WITHOUT ready → the original app UI becomes visible
      document.documentElement.classList.remove('hpo-pending');
      document.documentElement.classList.remove('hpo-ready');
      document.body.classList.remove('hpo-ready');
      var skeleton = root.querySelector('[data-hpo-skeleton]');
      if (skeleton) skeleton.remove();
      HPO.ready = false;
      console.warn('[HPO] disabled, app UI stays visible:', err);
    });
})();